import script from "./CapsuleFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CapsuleFilter.vue?vue&type=script&setup=true&lang=js"

import "./CapsuleFilter.vue?vue&type=style&index=0&id=6cf4f070&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf4f070"]])

export default __exports__